<template>
  <div class="ion-page">
    <ion-header translucent>
      <ion-toolbar>
        <ion-title>TonyTalks</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content fullscreen class="ion-padding">
      <h1>Details</h1>
      <h2>Service Worker Test</h2>
      <ion-button @click="logout">Log out</ion-button>
      <p>User defined {{ storedUser }}</p>
    </ion-content>
  </div>
</template>

<script>
import * as firebase from "firebase/app";

export default {
  name: "details",
  components: {},
  data() {
    return {
      info: null,
      i: 0,
      photo: ""
    };
  },
  computed: {
    storedUser() {
      return this.$store.state.user;
    }
  },
  created() {},
  methods: {
    logout() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.replace("login");
        });
    }
  }
};
</script>
